import Vue from 'vue';
import HomePage from '../views/public-facing/Home';
import RegistrationPage from '../views/public-facing/Register';
import BusinessDash from '../views/business-account/BusinessDash';
import PasswordReset from '../views/public-facing/ResetPassword';
import BusinessTargetMarket from '../views/business-account/Advertising/BusinessTargetMarketing';
import BusinessSearch from '../views/business-account/BusinessSearchEdit';
import BusinessBranding from '../views/business-account/Advertising/BusinessBranding';
import BusinessOffering from '../views/business-account/BusinessOfferings';
import PasswordStation from '../views/business-account/PasswordStation';
import BusinessOrganizeEvent from '../views/business-account/BusinessOrganizeEvent';
import BusinessFoodiePhotos from '../views/business-account/BusinessFoodiePhotos';
import GroupDeals from '../views/business-account/Advertising/BusinessPromos';
import SliderAd from '../views/business-account/Advertising/BusinessSliderAds';
import BusinessSettings from '../views/business-account/BusinessSettings';
import AdvertisingDash from '../views/business-account/Advertising/AdvertisingDash'
import EventSchedule from '../views/business-account/BusinessEventCalendar';
import BusinessPage from '../views/public-facing/Pages/HomePage';
import LogIn from '../views/public-facing/Login';
import Map from '../components/common/MapsComponent'
import ContractorDash from '../views/contractor-account/ContractorDash';
import ContractorListings from '../views/contractor-account/ContractorListings';
import ContractorRelocate from '../views/contractor-account/ContractorRelocate';
import Listing from '../views/contractor-account/Listing';
import Router from 'vue-router';
import store from '../plugins/vuex.mongo';
import PartnerTypeEnum from '../assets/Enums/PartnerTypeEnum';
import { MongoMixins } from '../mixins/mongo-mixins';


Vue.use(Router);

const AuthGuard = async (to, from, next) => {
  console.log('auth guard ' + store.getters.isAuthenticated);
  console.log('verify token ' + store.state.token);

  if (!store.getters.isAuthenticated) {
    return store.dispatch('VERIFY_TOKEN').then((data) => {
      if (data.VerifyToken.isValid) {
        next();
      } else {
        next('/');
      }
    }).catch(() => {
      next('/');
    })
  } else {
    return next();
  }
}

const EstablishmentPreferredGuard = (to, from, next) => {
  if (store.getters.isAuthenticated && store.getters.isEstablishment && store.getters.partnerType === PartnerTypeEnum.PREFERRED.number) {
    if (store.getters.refreshTime && store.getters.refreshTime.getTime() - 180000 < new Date().getTime()) {
      store.dispatch('TOUCH_API');
    }

    next()
  } else {
    if(store.getters.isEstablishment) {
      next('/business-dash');
    } else if(store.getters.isContractor) {
      next('/contractor-dash');
    } else {
      next();
    }
  }
}

const EstablishmentPremiumGuard = (to, from, next) => {
  if (store.getters.isAuthenticated && store.getters.isEstablishment && store.getters.partnerType >= PartnerTypeEnum.PREMIUM.number) {
    if (store.getters.refreshTime && store.getters.refreshTime.getTime() - 180000 < new Date().getTime()) {
      store.dispatch('TOUCH_API');
    }

    next()
  } else {
    if(store.getters.isEstablishment) {
      next('/business-dash');
    } else if(store.getters.isContractor) {
      next('/contractor-dash');
    } else {
      next();
    }
  }
}

const AccessTokenGuard = async (to, from, next) => {
  console.log('token guard ' + to.params.token + ' JWT ' + to.params.jwt);
  const result = await MongoMixins.methods.verifyToken(to.params.jwt, to.params.token);

  console.log('access result ', result);
  if (result.VerifyToken?.isValid) {
    next();
  } else {
    next('/login')
  }
}

const ContractorGuard = async (to, from, next) => {
  const result = await MongoMixins.methods.verifyToken(store.state.token);

  console.log('access result ', result);
  if (result.VerifyToken?.isValid && store.getters.isContractor) {
    next();
  } else {
    next('/login')
  }
}

//need to figure out how to adjust state isAuthenticated after email link sign in.
// const PasswordStationGuard = (to, from, next) => {
//   if(store.getters.isAuthenticated){
//     next();
//   } else {
//     next('')
//     console.log('not authenticated')
//   }
// }

export const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'reset-password',
      path: '/reset-password/:token/:jwt',
      component: PasswordReset,
      beforeEnter: AccessTokenGuard,
      props: true
    },
    {
      name: 'map',
      path: '/map',
      component: Map,
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      name: 'home-page',
      path: '',
      component: HomePage,
      beforeEnter: (to, from, next) => {
        if (store.getters.isAuthenticated) {
          next('/business-dash');
        } else {
          next()
        }
      },
    },
    {
      name: 'about',
      path: '/about',
      component: HomePage,
      beforeEnter: (to, from, next) => {
        console.log('about');
        next();
      },
    },
    {
      props: true,
      name: 'register',
      path: '/register/:acct?',
      component: RegistrationPage,
      beforeEnter: (to, from, next) => {
        console.log('register');
        next();
      }
    },
    {
      name: 'business-dash',
      path: '/business-dash',
      component: BusinessDash,
      beforeEnter: AuthGuard
    },
    {
      name: 'advertisement-dash',
      path: '/advertisement-dash',
      component: AdvertisingDash,
      beforeEnter: EstablishmentPremiumGuard
    },
    {
      name: 'business-edit-search',
      path: '/edit-search',
      component: BusinessSearch,
      beforeEnter: AuthGuard,
    },
    {
      name: 'business-target-markets',
      path: '/business-target-markets/:adIndex',
      component: BusinessTargetMarket,
      beforeEnter: EstablishmentPreferredGuard,
      props: true
    },
    {
      name: 'business-branding',
      path: '/business-branding',
      component: BusinessBranding,
      beforeEnter: AuthGuard,
    },
    {
      name: 'business-offering',
      path: '/business-offering',
      component: BusinessOffering,
      beforeEnter: AuthGuard,
    },
    {
      name: 'password-station',
      path: '/password-station',
      component: PasswordStation,
      beforeEnter: AuthGuard,
    },
    {
      name: 'business-login',
      path: '/login',
      component: LogIn,
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      name: 'business-organize-event',
      path: '/business-organize-event',
      component: BusinessOrganizeEvent,
      beforeEnter: EstablishmentPremiumGuard
    },
    {
      name: 'group-deals',
      path: '/group-deals',
      component: GroupDeals,
      beforeEnter: AuthGuard
    },
    {
      name: 'foodie-photos',
      path: '/foodie-photos',
      component: BusinessFoodiePhotos,
      beforeEnter: AuthGuard
    },
    {
      name: 'slider-ads',
      path: '/slider-ads',
      component: SliderAd,
      beforeEnter: AuthGuard
    },
    {
      name: 'settings',
      path: '/settings',
      component: BusinessSettings,
      beforeEnter: AuthGuard
    },
    {
      name: 'event-schedule',
      path: '/event-schedule',
      component: EventSchedule,
      beforeEnter: AuthGuard
    },
    {
      name: 'business-page',
      path: '/business-page/:busId/:pageType',
      component: BusinessPage,
      props: true
    }, 
    {
      name: 'contractor-dash',
      path: '/contractor-dash',
      component: ContractorDash
    },
    {
      name: 'contractor-relocate',
      path: '/contract-explore',
      component: ContractorRelocate
    },
    {
      name: 'contract-listings',
      path: '/contract-listings',
      component: ContractorListings,
      beforeEnter: ContractorGuard
    },
    {
      props: true,
      name: 'listing-page',
      path: '/contract-listings/:id',
      component: Listing,
      beforeEnter: ContractorGuard
    }
  ],
});
